import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectCategories, selectCateringCategories, selectIsModifyOrderMode, selectModifyOrderPax } from "../../redux/features/restaurants/restaurantSelectors";
import { transformCategories } from "../../utils/menu";
import Categories from "./categories";
import MenuItemsList from "./menuItemsList";
import CateringMenuList from "./cateringMenuList";
import PaxSelector from "../cateringPackages/PaxSelector";

export const Menu = ({ branchDetails, isCatering = false, activePackageId = null, displayName = null, disabled = false, packageData = null, isModifyOrderMode = false }) => {
  // Get modify order mode from Redux
  const reduxIsModifyOrderMode = useSelector(selectIsModifyOrderMode);
  const reduxModifyOrderPax = useSelector(selectModifyOrderPax);
  
  // Only apply modify order mode if explicitly passed OR Redux state confirms it
  const actualModifyMode = (isModifyOrderMode || reduxIsModifyOrderMode) && 
                          reduxModifyOrderPax !== null;
  
  console.log('🔍 Menu Component - Modify Mode Debug:', {
    'Props: isModifyOrderMode': isModifyOrderMode,
    'Redux: isModifyOrderMode': reduxIsModifyOrderMode,
    'Redux: modifyOrderPax': reduxModifyOrderPax,
    'Calculated: actualModifyMode': actualModifyMode,
    'Will disable PAX': actualModifyMode
  });
  const navigate = useNavigate();
  const categoriesList = useSelector(selectCategories);
  const cateringCategoriesList = useSelector(selectCateringCategories);
  const [activeCategory, setActiveCategory] = useState("All Menu");
  // const [orderedItems, setOrderedItems] = useState([]);
  // const [subtotal, setSubtotal] = useState(0);
  // const [tax, setTax] = useState(0.05); // 5% tax
  // const [deliveryCharges] = useState(0.5);
  const [searchQuery, setSearchQuery] = useState("");

  // const totalPayable = subtotal + subtotal * tax + deliveryCharges;

  // Use catering categories when in catering mode, otherwise use regular categories
  const selectedCategoriesList = isCatering ? cateringCategoriesList : categoriesList;
  const categories = selectedCategoriesList && transformCategories(selectedCategoriesList);
  
  // Debug logging for categories
  console.log("Menu component - isCatering:", isCatering);
  console.log("Menu component - selectedCategoriesList:", selectedCategoriesList);
  console.log("Menu component - transformed categories:", categories);

  const handleBackClick = () => {
    navigate(-1);
    // Alternative: navigate('/search'); // This will navigate specifically to /search
  };

  return (
    <>
      {/* Categories Section */}
      <div className="sm:w-full p-4 h-full flex flex-col">
        <div className="flex-shrink-0">
          <div className="flex flex-wrap items-center justify-between mb-4">
            <div className="flex items-center gap-4">
              <button 
                className="p-2"
                onClick={handleBackClick}
              >
                <img src="/Images/Menu/Bag.png" alt="Menu Bag" />
              </button>
              {displayName && (
                <h1 className="sm:text-3xl text-2xl text-amber-100 font-bold">
                  {displayName}
                </h1>
              )}
            </div>
            <div className="flex items-center gap-4 w-full sm:w-auto mt-4 sm:mt-0">
              {isCatering && <PaxSelector disabled={actualModifyMode} />}
              <div className="relative">
                <input
                  type="text"
                  className="w-full sm:w-[235px] h-11 rounded-xl p-2 pl-10 border-2 text-xs text-gray-700 font-bold border-gray-300"
                  placeholder="Search Item"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value.toLowerCase())} // Convert to lowercase for case-insensitive search
                />
                <img
                  src="/Images/Menu/Icon - Search.png"
                  alt="Search Icon"
                  className="absolute left-4 top-1/2 transform -translate-y-1/2"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex-shrink-0">
          <Categories
            categories={categories}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            disabled={disabled}
            isCatering={isCatering}
            packageData={packageData}
          />
        </div>
        <img src="/Images/Menu/hr.png" className="mt-8 w-[850px] flex-shrink-0"></img>
        <div className={`flex-1 min-h-0 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
          {isCatering ? (
            <CateringMenuList activeCategory={activeCategory} searchQuery={searchQuery} activePackageId={activePackageId} disabled={disabled} isModifyOrderMode={actualModifyMode}/>
          ) : (
            <MenuItemsList activeCategory={activeCategory} searchQuery={searchQuery} branchDetails={branchDetails} disabled={disabled}/>
          )}
        </div>
      </div>
    </>
  );
};
